module.exports = "<nav class=\"navbar navbar-expand-lg navbar-light bg-light\" role=\"navigation\">\n    <a class=\"navbar-brand\" href=\"/\">NNDDCC</a>\n</nav>\n\n<app-notification></app-notification>\n\n<app-busy-indicator></app-busy-indicator>\n\n<h1 class=\"container\">FirstMedia Show Schedule / Jadwal Acara FirstMedia</h1>\n\n<br />\n\n<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// D:/OTHERS/FirstmediaShowSchedule/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main